// Netplus Modem Recovery & Recharges — shared constants + helpers.

// This module is only available for the "Satti & Co" project.
export const NETPLUS_MODEM_PROJECT_ID = "6a5b3b03d523f05425426dbc";

export const BUCKETS = [
  { key: "inactive", label: "Inactive" },
  { key: "suspended", label: "Suspended" },
  { key: "terminated", label: "Terminated" },
];

export const BUCKET_KEYS = BUCKETS.map((b) => b.key);

export const MOVEMENTS = [
  { key: "recovered", label: "Recovered", sign: -1, hint: "Modem collected back" },
  { key: "recharge", label: "Recharge", sign: -1, hint: "Subscriber recharged" },
  { key: "added", label: "Added", sign: +1, hint: "New connection into bucket" },
];

export const zeroBucket = () => ({ inactive: 0, suspended: 0, terminated: 0 });

export const bucketTotal = (b = {}) =>
  BUCKET_KEYS.reduce((sum, k) => sum + (Number(b?.[k]) || 0), 0);

export const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const toDateInputValue = (value = new Date()) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;
};

export const formatDateLabel = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const monthValue = (value = new Date()) => {
  const d = new Date(value);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric",
  });
};
